import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18nPromise = fetch('https://api.crowdl.io/ratemytactic/cdn/en.json')
.then(response => response.json())
.then(en => {
  return new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: { en }
  });
});
